







































































































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {EssenceAchat} from '@/models';

import storeEssenceAchat from '@/stores/modules/essenceAchat';
import storeLongueursAchat from "@/stores/modules/longueursAchat";
import storeBoisType from "@/stores/modules/boisType";

import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
import CrudClientSearch from "@/components/Crud/Client/Search.vue";
import CrudLongueursAchatSearch from "@/components/Crud/LongueursAchat/Search.vue";
import CrudBoisTypeSearch from "@/components/Crud/BoisType/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputLongueursAchat from "@/components/Input/LongueursAchat.vue";
import InputDatePicker from "@/components/Input/DatePicker.vue";

@Component({
	components: {
		CrudTransporteurSearch,
		CrudClientSearch,
		CrudLongueursAchatSearch,
		CrudBoisTypeSearch,
		InputBoisType,
		InputLongueursAchat,
		InputDatePicker,
	}
})
export default class CrudEssenceAchatEdit extends AbstractEditVue<EssenceAchat> {

	private storeLongueursAchat = storeLongueursAchat
	private storeBoisType = storeBoisType;

	public constructor() {
		super(
			storeEssenceAchat,
			'Essence achetée modifié',
			'Essence achetée créé',
		);
	}

	public async mounted(): Promise<void> {
		await storeLongueursAchat.dispatch('getC', {filters: false});
		await storeBoisType.dispatch('getC', {filters: false});
		await super.mounted();
	}

}
